<ngb-toast
  (hide)="toastService.removeToast(toast)"
  *ngFor="let toast of toastService.toasts.getValue()"
  [autohide]="true"
  [class]="toast.classname"
  [delay]="toast.delay || 5000"
>
  <app-toast-info *ngIf="toast.type === 'toastInfo'" [toast$]="toast"></app-toast-info>
  <app-toast-acknowledgment *ngIf="toast.type === 'toastAcknowledgement'" [toast$]="toast"></app-toast-acknowledgment>
  <app-toast-error *ngIf="toast.type === 'toastError'" [toast$]="toast"></app-toast-error>
  <app-toast-warning *ngIf="toast.type === 'toastWarning'" [toast$]="toast"></app-toast-warning>
  <app-toast-redirect *ngIf="toast.type === 'toastRedirection'" [toast$]="toast"></app-toast-redirect>
  <!-- Add additional toast types and target it with *ngIf as done above -->
</ngb-toast>
